import { environment } from "src/environments/environment";
import { AppStatusFilter } from "src/app/models/enums/appStatusFilter";
import { BookingsFilter } from "src/app/models/enums/bookingsFilter";
import { ClientType } from "src/app/models/enums/clientType";
import { ErrorsCode } from "src/app/models/enums/errorsCode";
import { IntegrationsTab } from "src/app/models/enums/integrationsTab";
import { ManagementQueryParam } from "src/app/models/enums/managementQueryParam";
import { Colors } from "src/app/models/enums/colors";
import { CommunicationUserType } from "src/app/models/enums/communicationsUserType";
import { DriverSuggestionType } from "src/app/models/enums/driverSuggestionType";
import { ExpeditionStatus, ExpeditionStatusGroup } from "src/app/models/enums/expeditionStatus";
import { ExpeditionType } from "src/app/models/enums/expeditionType";
import { FilterField, FilterFieldKind } from "src/app/models/enums/filterField";
import { IdentityProviderField } from "src/app/models/enums/identityProviderField";
import { FilterType } from "src/app/models/enums/filterType";
import { MessageOrigin } from "src/app/models/enums/messageOrigin";
import { MessageAdminAlertsFilter } from "src/app/models/enums/messageAdminAlertsFilter";
import { MessageChannel } from "src/app/models/enums/messageChannel";
import { MessageStatus } from "src/app/models/enums/messageStatus";
import { NotificationChannel } from "src/app/models/enums/notificationChannel";
import { SuggestionPriority } from "src/app/models/enums/suggestionPriority";
import { SuggestionStatus } from "src/app/models/enums/suggestionStatus";
import { SuggestionType } from "src/app/models/enums/suggestionType";
import { SuggestionUserResolutionFilter } from "src/app/models/enums/suggestionUserResolution";
import { SuggestionVisibility } from "src/app/models/enums/suggestionVisibility";
import { TimelineDaysPreset } from "src/app/models/enums/timelineDaysPreset";
import { TimelineHoursPreset } from "src/app/models/enums/timelineHoursPreset";
import { ScheduleViewOption } from "src/app/models/enums/scheduleViewOption";
import { ScheduleViewMode } from "src/app/models/enums/scheduleViewMode";
import { ServiceType } from "src/app/models/enums/serviceType";
import { TripsViewMode } from "src/app/models/enums/tripsViewMode";
import { ItinerarySortType } from "src/app/models/enums/itinerarySortType";
import { SortDirection } from "src/app/models/enums/sortDirection";
import { SuggestionSortType } from "src/app/models/enums/suggestionSortType";
import { UserStatus } from "src/app/models/enums/userStatus";
import { UserType } from "src/app/models/enums/userType";
import { FilterListKey, IFilterFieldDefinition, IStatusGroupDefinition } from "src/app/models/filterPanel";
import { IBlockPalette, IScheduleViewOptions, ISkeletonBlock } from "src/app/models/vehicleSchedule";
import { ConnectedPosition } from "@angular/cdk/overlay";
import { ILegacyValueRule } from "src/app/models/legacyValueRule";

export class APP {
  // STORAGE
  public static LOCAL_STORAGE_TOKEN_KEY_NAME = 'token';
  public static LOCAL_STORAGE_TOKEN_DECODED = 'decodedToken';
  public static LOCAL_STORAGE_TOKEN_TYPE_KEY_NAME = 'tokenType';
  public static LOCAL_STORAGE_ROLE = 'role';
  public static LOCAL_STORAGE_REFRESH_TOKEN = environment.location === 'prod' ? 'refreshToken' : 'refreshToken' + `-${environment.location}`;
  public static LOCAL_STORAGE_USER_ID = environment.location === 'prod' ? 'userId' : 'userId' + `-${environment.location}`;
  public static LOCAL_STORAGE_LAST_ROUTE = 'route';
  public static LOCAL_STORAGE_MAP_CONFIG = 'mapConfig';
  public static LOCAL_STORAGE_HIDE_SHARED_STOP_ALERT = 'hideSharedStopAlert';
  public static LOCAL_STORAGE_HIDDEN_ROUTES = 'hiddenRoutes';

  public static DEFAULT_PAGE_SIZE = 10;

  // Favourites persist a D2D free stop (lat/lng only) with these sentinel ids; they are not real stop ids.
  public static FAVOURITE_FREE_IN_STOP_ID = 0;
  public static FAVOURITE_FREE_OUT_STOP_ID = 1;

  public static MAXQUEUE_EMAIL = 8000;
  public static MAXQUEUE_PUSHNOTIFICATION = 8000;
  public static MAXQUEUE_SMS = 200;

  // AUTH
  public static HEADER_RESPONSE_TOKEN_AUTH_KEY = 'Authorization';
  public static PASSWORD_MIN_LENGTH = 12;
  public static SIGN_IN_MAX_ATTEMPTS = 5;
  public static SIGN_IN_CODE_LENGTH = 8;
  public static SIGN_IN_INITIAL_TIMER = '02:00';
  public static SIGN_IN_PASSWORD_RESET_TIMER = '03:00';
  public static SIGN_IN_TIME_FINISHED = '00:00';
  public static DEFAULT_ROUTE = 'suggestions';

  public static appsPrivacyAndTermsOptions = [
    { name: 'Nemi', privacy: `http://www.nemi.mobi/app/legal/`, terms: `http://www.nemi.mobi/app/terms/`, owner: 'Nemi Mobility Solutions SL', someLanguages: true },
    { name: 'AMB', privacy: 'http://www.amb.cat/web/mobilitat/autobus/busademanda/cervello', terms: 'http://www.amb.cat/web/mobilitat/autobus/busademanda/cervello', owner: null, someLanguages: false },
    { name: 'SierraCar', privacy: 'https://sierracar.es/politica-privacidad/', terms: 'https://sierracar.es/wp-content/uploads/2021/03/TC_SierraCar.pdf', owner: 'la Mancomunidad de servicios Valle Norte del Lozoya', someLanguages: false },
    { name: 'Cotsalsina', privacy: `http://www.nemi.mobi/cotsalsina/legal/`, terms: `http://www.nemi.mobi/cotsalsina/terms/`, owner: 'Cots Alsina SL', someLanguages: false },
    { name: 'Pnds', privacy: `http://www.nemi.mobi/pnds/legal/`, terms: `http://www.nemi.mobi/pnds/terms/`, owner: 'Autocares del Panades SA', someLanguages: false },
    { name: 'Tuvisa', privacy: `http://www.nemi.mobi/tuvisa/legal/`, terms: `http://www.nemi.mobi/tuvisa/terms/`, owner: 'el Ayuntamiento de Vitoria-Gasteiz', someLanguages: false },
    { name: 'Dipucar', privacy: `http://www.nemi.mobi/dipucar/legal/`, terms: `http://www.nemi.mobi/dipucar/terms/`, owner: 'la Diputación Provincial de Palencia', someLanguages: false }
  ];

  // ROUTE SETUP CONFIG
  public static DEFAULT_STOP_RADIUS = 75;
  public static MIN_STOP_RADIUS = 1;
  public static MAX_STOP_RADIUS = 999;
  public static DEFAULT_DRIVING_SPEED = 50;
  public static TOWN_STOP_METADATA_PROPERTIES = ['gtfs-id', 'parking-length', 'parking-number', 'parking-orientation'] as const;
  public static ORDERED_STOPS_TYPE = 'orderedStops';
  public static ROUTE_DESIGN_UNSAVED_CHANGES_KEY = 'services.routes.design.leave.description';

  // MAP
  public static DEFAULT_MAP_ZOOM = 15;
  public static TOWN_ZOOM_MIN_SPAN = 0.01;
  public static ROUTE_WAYPOINTS_CHUNK_SIZE = 25;

  // USERS
  public static USER_BOOKINGS_REFRESH_MS = 60000;

  // SIDEBAR
  public static SIDEBAR_OPEN_DELAY_MS = 500;
  public static SIDEBAR_CLOSE_DELAY_MS = 200;

  // SUPERADMIN ZONE
  public static PAGE_TITLE_SUFFIX = ' - NEMI Backoffice';
  public static MANAGEMENT_DETAIL_ID_PARAM = 'id';
  public static MANAGEMENT_NEW_DETAIL_ID = 'new';
  public static MANAGEMENT_FILTER_VALUES_SEPARATOR = ',';
  public static MANAGEMENT_DETAIL_QUERY_PARAMS = [ManagementQueryParam.TAB];
  public static ERROR_CODES_WITH_ENTITY_INFO = [ErrorsCode.INVALID_REQUEST, ErrorsCode.ENTITY_ALREADY_ASSIGNED];
  public static SUPERADMIN_LIST_FILTERS_VISIBLE = false;
  public static SUGGESTIONS_PRIORITY_STATUS_COLUMN_FILTERS_VISIBLE = false;
  public static STATUS_BUTTON_DEACTIVATE_CLASSES = 'border-primary-purple border-solid border';
  public static STATUS_BUTTON_ACTIVATE_CLASSES = 'bg-primary-purple text-white';
  public static CLIENTS_FILTER_FIELDS = [FilterField.CLIENT_TYPES];
  public static APPS_FILTER_FIELDS = [FilterField.APP_STATUS];
  public static SUPERADMIN_SELECT_OPTIONS_PAGE_SIZE = 50;
  public static SUPERADMIN_FORM_OPTIONS_PAGE_SIZE = 200;
  public static INTEGRATIONS_TAB_LABELS: Record<IntegrationsTab, string> = {
    [IntegrationsTab.APPS]: 'APP',
    [IntegrationsTab.IDENTITY_PROVIDERS]: 'IDP',
    [IntegrationsTab.SAE_INTEGRATIONS]: 'SAE',
  };
  public static IDENTITY_PROVIDER_UNIQUE_ID_TYPES = [
    IdentityProviderField.ID,
    IdentityProviderField.EMAIL,
    IdentityProviderField.PHONE_NUMBER,
  ];
  public static IDENTITY_PROVIDER_FIELDS_TO_SAVE = [
    IdentityProviderField.EMAIL,
    IdentityProviderField.FULL_NAME,
    IdentityProviderField.PHONE_NUMBER,
    IdentityProviderField.LANGUAGE,
    IdentityProviderField.ADDITIONAL_PHONE,
    IdentityProviderField.SETTLEMENT,
    IdentityProviderField.GENDER,
    IdentityProviderField.BIRTH_DATE,
    IdentityProviderField.IS_PRM,
  ];

  // VEHICLE SCHEDULE
  public static MINUTES_PER_HOUR = 60;
  public static MINUTES_PER_DAY = 24 * 60;
  public static MINUTES_PER_WEEK = 7 * 24 * 60;
  public static SCHEDULE_DEFAULT_VIEWPORT_WIDTH = 1200;
  public static SCHEDULE_VISIBLE_PERIODS = 20;
  public static VEHICLES_PATH = '/vehicles';
  public static SCHEDULE_PERIOD_SWITCH_RATIO = 0.25;
  public static SCHEDULE_SCROLL_SETTLE_MS = 150;
  public static SCHEDULE_VIEW_MODE_LABELS: Record<ScheduleViewMode, string> = {
    [ScheduleViewMode.DAY]: 'vehicles.day',
    [ScheduleViewMode.WEEK]: 'vehicles.week',
  };
  public static SCHEDULE_DEFAULT_VIEW_OPTIONS: IScheduleViewOptions = {
    [ScheduleViewOption.SHOW_AVAILABILITIES]: true,
    [ScheduleViewOption.HIDE_EMPTY_ROWS]: true,
  };
  public static SCHEDULE_SCROLL_LOAD_THRESHOLD_PX = 96;
  public static SCHEDULE_DRAG_SPEED_MULTIPLIER = 2;
  // periods fetched beyond the axis, so stepping into the next days costs no request
  public static SCHEDULE_PREFETCHED_PERIODS = 1;
  public static SCHEDULE_ZOOM_ANIMATION_MS = 250;
  public static SCHEDULE_MOVE_ANIMATION_MS = 600;
  public static SCHEDULE_HEADER_HEIGHT_PX = 32;
  public static SCHEDULE_FOLLOW_PADDING_PX = 24;
  public static SCHEDULE_DRAG_SNAP_MINUTES = 5;
  public static SCHEDULE_DRAG_THRESHOLD_PX = 4;
  public static SCHEDULE_DRAG_LONG_PRESS_MS = 400;
  public static SCHEDULE_DRAG_AUTO_SCROLL_EDGE_PX = 40;
  public static SCHEDULE_DRAG_AUTO_SCROLL_STEP_PX = 12;
  public static SCHEDULE_MIN_TRIP_CHIP_WIDTH_PX = 16;
  public static SCHEDULE_TRIP_CHIP_HEIGHT_PX = 32;
  public static SCHEDULE_TRIP_CHIP_MIN_HEIGHT_PX = 18;
  public static SCHEDULE_TRIP_CHIP_GAP_PX = 4;
  public static SCHEDULE_ROW_PADDING_PX = 4;
  public static SCHEDULE_ROW_MIN_HEIGHT_PX = 60;
  public static SCHEDULE_BLOCK_LABEL_HEIGHT_PX = 16;
  public static SCHEDULE_BLOCK_BOTTOM_PADDING_PX = 4;
  public static SCHEDULE_BLOCK_GAP_PX = 4;
  public static SCHEDULE_COLLAPSED_HOURS_WIDTH_PX = 24;
  public static SCHEDULE_COLLAPSED_ROW_HEIGHT_PX = 8;
  public static SCHEDULE_ALL_HOURS = Array.from({ length: 24 }, (_, hour) => hour);
  public static SCHEDULE_HOURS_PRESETS: Record<TimelineHoursPreset, number[]> = {
    [TimelineHoursPreset.MORNING]: APP.SCHEDULE_ALL_HOURS.filter((hour) => hour >= 6 && hour < 14),
    [TimelineHoursPreset.AFTERNOON]: APP.SCHEDULE_ALL_HOURS.filter((hour) => hour >= 14 && hour < 22),
    [TimelineHoursPreset.DAY]: APP.SCHEDULE_ALL_HOURS.filter((hour) => hour >= 6 && hour < 22),
    [TimelineHoursPreset.NIGHT]: APP.SCHEDULE_ALL_HOURS.filter((hour) => hour >= 22 || hour < 6),
    [TimelineHoursPreset.COMPLETE_DAY]: APP.SCHEDULE_ALL_HOURS,
  };
  public static SCHEDULE_ALL_WEEKDAYS = Array.from({ length: 7 }, (_, day) => day);
  public static SCHEDULE_WEEKDAY_KEYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
  public static SCHEDULE_DAYS_PRESETS: Record<TimelineDaysPreset, number[]> = {
    [TimelineDaysPreset.WEEKDAYS]: APP.SCHEDULE_ALL_WEEKDAYS.filter((day) => day < 5),
    [TimelineDaysPreset.WEEKEND]: APP.SCHEDULE_ALL_WEEKDAYS.filter((day) => day >= 5),
    [TimelineDaysPreset.COMPLETE_WEEK]: APP.SCHEDULE_ALL_WEEKDAYS,
  };
  public static SCHEDULE_VEHICLE_COLUMN_WIDTH_PX = 112;
  public static SCHEDULE_LOCAL_DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
  public static SCHEDULE_SUMMARY_START_FORMAT = 'DD/MM HH:mm';
  public static SCHEDULE_SUMMARY_END_FORMAT = 'HH:mm';
  // scattered along the axis so the placeholder rows read like a schedule instead of a stack of bars
  public static SCHEDULE_SKELETON_LAYOUT: ISkeletonBlock[][] = [
    [{ start: 0.06, width: 0.11 }, { start: 0.34, width: 0.08 }, { start: 0.66, width: 0.13 }],
    [{ start: 0.19, width: 0.09 }, { start: 0.52, width: 0.14 }],
    [{ start: 0.04, width: 0.07 }, { start: 0.27, width: 0.12 }, { start: 0.58, width: 0.09 }, { start: 0.81, width: 0.07 }],
    [{ start: 0.41, width: 0.16 }],
    [{ start: 0.12, width: 0.13 }, { start: 0.47, width: 0.07 }, { start: 0.72, width: 0.11 }],
    [{ start: 0.23, width: 0.08 }, { start: 0.61, width: 0.15 }],
  ];
  public static SCHEDULE_COPY_BLOCK_OPACITY_PERCENT = 70;
  public static SCHEDULE_NEUTRAL_PALETTE: IBlockPalette = {
    block: 'var(--color-neutrals-grey-01)',
    blockHover: 'color-mix(in srgb, var(--color-neutrals-grey-01) 90%, black)',
    border: 'var(--color-neutrals-grey-02)',
    chip: 'var(--color-neutrals-grey-04)',
    chipHover: 'color-mix(in srgb, var(--color-neutrals-grey-04) 90%, white)',
    label: 'var(--color-neutrals-grey-06)',
  };
  public static SCHEDULE_EDITOR_POSITIONS: ConnectedPosition[] = [
    { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top', offsetY: 4 },
    { originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom', offsetY: -4 },
    { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top', offsetY: 4 },
    { originX: 'end', originY: 'top', overlayX: 'end', overlayY: 'bottom', offsetY: -4 },
  ];

  // TRIP POSITIONS
  public static TRIPS_BASE_PATHS: Record<TripsViewMode, string> = {
    [TripsViewMode.TRIPS]: '/trips',
    [TripsViewMode.POSITIONS]: '/trips/positions',
  };
  public static TRIPS_PAGE_SIZE = 8;
  public static POSITIONS_PAGE_SIZE = 6;
  public static MS_PER_SECOND = 1000;
  public static SECONDS_PER_MINUTE = 60;
  public static SECONDS_PER_DAY = APP.MINUTES_PER_DAY * APP.SECONDS_PER_MINUTE;
  public static TRIPS_FILTER_FIELDS: FilterField[] = [
    FilterField.CLIENTS,
    FilterField.OPERATORS,
    FilterField.AREAS_SERVICES_ROUTES,
    FilterField.DATE_RANGE,
    FilterField.SERVICE_TYPES,
    FilterField.EXPEDITION_MODES,
    FilterField.EXPEDITION_STATUS,
  ];
  public static VEHICLES_FILTER_FIELDS: FilterField[] = [
    FilterField.CLIENTS,
    FilterField.OPERATORS,
    FilterField.AREAS_SERVICES_ROUTES,
    FilterField.VEHICLES,
    FilterField.DRIVERS,
    FilterField.DATE_RANGE,
    FilterField.SERVICE_TYPES,
    FilterField.EXPEDITION_MODES,
  ];
  public static SERVICES_FILTER_FIELDS: FilterField[] = [
    FilterField.CLIENTS,
    FilterField.SERVICES_ROUTES,
    FilterField.SERVICE_TYPES,
    FilterField.EXPEDITION_MODES,
  ];
  public static POSITIONS_PLAYER_SPEEDS = [1, 4, 8];
  public static POSITIONS_PLAYER_TICK_MS = 250;
  public static POSITIONS_PLAYER_HOUR_LABEL_STEP = 6;
  public static POSITIONS_PLAYER_MAX_GAP_MINUTES = 10;
  public static POSITIONS_PLAYER_TRIP_MIN_INNER_LABELS = 3;
  public static POSITIONS_PLAYER_TRIP_MAX_INNER_LABELS = 7;
  public static POSITIONS_PLAYER_TRIP_LABEL_ROUNDING_MINUTES = 5;
  public static POSITIONS_PLAYER_TRIP_TICKS_BETWEEN_LABELS = 4;
  public static POSITIONS_PLAYER_KEYBOARD_STEP_MINUTES = 5;
  public static POSITIONS_PLAYER_SPACE_IGNORED_TARGETS =
    'input:not([type="range"]), textarea, select, button, [contenteditable="true"]';
  public static POSITIONS_PLAYER_ARROW_IGNORED_TARGETS =
    'input:not([type="range"]), textarea, select, [contenteditable="true"]';
  public static POSITIONS_DAY_PARAM = 'day';
  public static POSITIONS_DAY_FORMAT = 'YYYY-MM-DD';
  public static POSITIONS_CALENDAR_DAY_FORMAT = 'DD/MM/YYYY';
  public static CALENDAR_TYPED_DATE_PATTERN = /[^\d/]/g;
  public static CALENDAR_TYPED_DATE_MAX_LENGTH = 10;
  public static POSITIONS_REFRESH_INTERVAL_MS = 60000;
  public static POSITIONS_VEHICLE_MARKER_Z_INDEX = 100;
  public static POSITIONS_MAP_CONTROLS_OFFSET_PX = 80;

  // ITINERARIES
  public static ITINERARIES_PAGE_SIZE = 8;
  public static ITINERARIES_PAGE_PARAM = 'page';
  public static ITINERARIES_SORT_PARAM = 'sort';
  public static ITINERARIES_DIRECTION_PARAM = 'direction';
  public static ITINERARIES_DEFAULT_SORT = ItinerarySortType.CREATION;
  public static ITINERARIES_DEFAULT_DIRECTIONS: Record<ItinerarySortType, SortDirection> = {
    [ItinerarySortType.CODE]: SortDirection.ASC,
    [ItinerarySortType.TIMES_USED]: SortDirection.DESC,
    [ItinerarySortType.DISTANCE]: SortDirection.ASC,
    [ItinerarySortType.DURATION]: SortDirection.ASC,
    [ItinerarySortType.CREATION]: SortDirection.DESC,
    [ItinerarySortType.LAST_USE]: SortDirection.DESC,
  };
  public static ITINERARY_TRIPS_STATUS = [
    ExpeditionStatus.OPEN,
    ExpeditionStatus.READY,
    ExpeditionStatus.ONGOING,
    ExpeditionStatus.CLOSED,
  ];
  public static ITINERARIES_PATH_STROKE_WEIGHT = 5;
  public static ITINERARIES_MUTED_PATH_STROKE_WEIGHT = 3;
  public static ITINERARIES_MUTED_PATH_COLOR = '--color-neutrals-grey-04';
  public static ITINERARIES_HIGHLIGHTED_PATH_Z_INDEX = 10;
  public static ITINERARIES_FEATURE_ID_PROPERTY = 'itineraryId';
  public static ITINERARIES_STOP_ZOOM = 17;
  public static ITINERARIES_MAP_PADDING = { top: 40, bottom: 30, left: 800, right: 10 };
  public static ITINERARIES_ORIGIN_MARKER_Z_INDEX = 50;
  public static ITINERARIES_DESTINATION_MARKER_Z_INDEX = 40;
  public static ITINERARIES_STOP_MARKER_Z_INDEX = 20;

  // OPERATION PROGRESS WEBSOCKET
  public static WEBSOCKET_KEEPALIVE_MS = 20000;
  public static WEBSOCKET_KEEPALIVE_MESSAGE = 'PING';
  public static WEBSOCKET_RECONNECT_ATTEMPTS = 5;
  public static WEBSOCKET_RECONNECT_DELAY_MS = 2000;

  // LIST EXPORT
  public static LIST_EXPORT_MIME_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  public static LIST_EXPORT_DEFAULT_FILE_NAME = 'export.xlsx';

  // ROUTE REORGANIZATION
  public static REORGANIZATION_WEEK_DAYS = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
  public static REORGANIZATION_DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
  public static REORGANIZATION_EXPEDITION_TYPES_BY_FLEXIBILITY = [
    ExpeditionType.Fixed,
    ExpeditionType.HybridWithFixedPoints,
    ExpeditionType.DynamicWithFixedPoints,
    ExpeditionType.HybridDoor2Door,
    ExpeditionType.DynamicDoor2Door,
  ];
  public static REORGANIZATION_PLANNABLE_STATUS = [ExpeditionStatus.OPEN, ExpeditionStatus.READY];
  public static REORGANIZATION_MAX_ITEMS = 1000;
  public static REORGANIZATION_CANCEL_BOOKING = 'cancel';
  public static REORGANIZATION_MIN_SPLIT_ROUTES = 2;

  // CUSTOM TOGGLE
  public static CUSTOM_TOGGLE_ICON_FADE_MS = 300;
  public static CUSTOM_TOGGLE_DRAG_THRESHOLD_PX = 4;

  // COLORS
  public static HEX_COLOR_PATTERN = /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6})$/;
  public static HEX_COLOR_MAX_LENGTH = 7;

  // LEGACY VALUES
  public static LEGACY_VALUE_RULES: ILegacyValueRule[] = [
    { key: 'color', legacyValue: '#FFFFFFFF', value: Colors.TRANSPARENT },
  ];
  public static LEGACY_TERRAIN_KEYS: Record<string, string> = {
    connection_ids: 'connection-ids',
    intersection_ids: 'intersection-ids',
    town_segment_ids: 'town-segment-ids',
  };

  public static PREDEFINED_COLORS = new Set<string>([
    Colors.TRANSPARENT,
    Colors.BLUE,
    Colors.ORANGE_1,
    Colors.ORANGE_2,
    Colors.PINK,
    Colors.PURPLE,
    Colors.PURPLE_LIGHT,
    Colors.PRIMARY_GREEN,
    Colors.SECONDARY_GREEN,
    Colors.RED,
    Colors.YELLOW,
    Colors.GREY,
  ]);

  // COLUMN FILTER
  public static COLUMN_FILTER_SCROLL_LOAD_THRESHOLD_PX = 48;
  public static COLUMN_FILTER_SKELETON_ROWS = 7;
  public static COLUMN_FILTER_SEARCH_DEBOUNCE_MS = 300;

  // FILTERS
  public static FILTER_FIELDS: Record<FilterField, IFilterFieldDefinition> = {
    [FilterField.CLIENTS]: {
      kind: FilterFieldKind.MULTISELECT,
      label: 'fieldFilters.clients',
    },
    [FilterField.AREAS]: {
      kind: FilterFieldKind.MULTISELECT,
      label: 'fieldFilters.areas',
      parent: FilterField.CLIENTS,
    },
    [FilterField.AREAS_SERVICES]: {
      kind: FilterFieldKind.AREAS_SERVICES,
      label: 'fieldFilters.areasServices',
      parent: FilterField.CLIENTS,
    },
    [FilterField.AREAS_SERVICES_ROUTES]: {
      kind: FilterFieldKind.AREAS_SERVICES,
      label: 'fieldFilters.areasServicesRoutes',
      parent: FilterField.CLIENTS,
      showsRoutes: true,
    },
    [FilterField.AREAS_SERVICES_EXPEDITIONS]: {
      kind: FilterFieldKind.AREAS_SERVICES,
      label: 'fieldFilters.areasServicesExpeditions',
      parent: FilterField.CLIENTS,
    },
    [FilterField.SERVICES_ROUTES]: {
      kind: FilterFieldKind.AREAS_SERVICES,
      label: 'fieldFilters.servicesRoutes',
      parent: FilterField.CLIENTS,
      hidesAreas: true,
      showsRoutes: true,
    },
    [FilterField.OPERATORS]: {
      kind: FilterFieldKind.MULTISELECT,
      label: 'fieldFilters.operators',
      parent: FilterField.CLIENTS,
      stacksUnder: FilterField.CLIENTS,
    },
    [FilterField.SENDERS]: {
      kind: FilterFieldKind.MULTISELECT,
      label: 'fieldFilters.senders',
    },
    [FilterField.RECEIVERS]: {
      kind: FilterFieldKind.RECEIVERS,
      label: 'fieldFilters.receivers',
    },
    [FilterField.VEHICLES]: {
      kind: FilterFieldKind.MULTISELECT_SCROLL,
      label: 'fieldFilters.vehicles',
    },
    [FilterField.DRIVERS]: {
      kind: FilterFieldKind.MULTISELECT_SCROLL,
      label: 'fieldFilters.drivers',
      stacksUnder: FilterField.VEHICLES,
    },
    [FilterField.ORIGIN_DESTINATION]: {
      kind: FilterFieldKind.ORIGIN_DESTINATION,
      label: 'fieldFilters.originDestination',
    },
    [FilterField.DATE_RANGE]: {
      kind: FilterFieldKind.DATE_RANGE,
      label: 'fieldFilters.dateRange',
    },
    [FilterField.TIME_RANGE]: {
      kind: FilterFieldKind.TIME_RANGE,
      label: 'fieldFilters.timeRange',
    },
    [FilterField.BOOKINGS]: {
      kind: FilterFieldKind.CHECKBOX_GROUP,
      label: 'fieldFilters.bookings',
      optionLabelPrefix: 'availabilities.bookings.',
      defaultChecked: true,
    },
    [FilterField.EXPEDITION_STATUS]: {
      kind: FilterFieldKind.STATUS_GROUP,
      label: 'fieldFilters.expeditionStatus',
    },
    [FilterField.EXPEDITION_TYPES]: {
      kind: FilterFieldKind.CHECKBOX_GROUP,
      label: 'fieldFilters.expeditionTypes',
      rawOptionLabels: true,
    },
    [FilterField.CLIENT_TYPES]: {
      kind: FilterFieldKind.CHECKBOX_GROUP,
      label: 'fieldFilters.clientTypes',
      optionLabelPrefix: 'clients.clientTypes.',
      rawOptionLabels: true,
    },
    [FilterField.APP_STATUS]: {
      kind: FilterFieldKind.CHECKBOX_GROUP,
      label: 'fieldFilters.appStatus',
    },
    [FilterField.SERVICE_TYPES]: {
      kind: FilterFieldKind.OPTION_MULTISELECT,
      label: 'fieldFilters.serviceTypes',
      rawOptionLabels: true,
    },
    [FilterField.EXPEDITION_MODES]: {
      kind: FilterFieldKind.OPTION_MULTISELECT,
      label: 'fieldFilters.expeditionModes',
      rawOptionLabels: true,
      stacksUnder: FilterField.SERVICE_TYPES,
    },
    [FilterField.USER_STATUS]: {
      kind: FilterFieldKind.CHECKBOX_GROUP,
      label: 'fieldFilters.userStatus',
    },
    [FilterField.USER_TYPES]: {
      kind: FilterFieldKind.CHECKBOX_GROUP,
      label: 'fieldFilters.userTypes',
    },
    [FilterField.SUGGESTION_STATUS]: {
      kind: FilterFieldKind.CHECKBOX_GROUP,
      label: 'fieldFilters.suggestionStatus',
      optionLabelPrefix: 'suggestions.statuses.',
    },
    [FilterField.SUGGESTION_TYPES]: {
      kind: FilterFieldKind.CHECKBOX_GROUP,
      label: 'fieldFilters.suggestionTypes',
      optionLabelPrefix: 'suggestions.',
    },
    [FilterField.SUGGESTION_PRIORITIES]: {
      kind: FilterFieldKind.CHECKBOX_GROUP,
      label: 'fieldFilters.suggestionPriorities',
      optionLabelPrefix: 'suggestions.priorities.',
    },
    [FilterField.SUGGESTION_USER_RESOLUTIONS]: {
      kind: FilterFieldKind.CHECKBOX_GROUP,
      label: 'suggestions.data.userResolution',
      optionLabelPrefix: 'suggestions.userResolutions.',
      rawOptionLabels: true,
    },
    [FilterField.SUGGESTION_VISIBILITIES]: {
      kind: FilterFieldKind.CHECKBOX_GROUP,
      label: 'suggestions.data.visibility',
      optionLabelPrefix: 'suggestions.visibilities.',
      optionTooltipPrefix: 'suggestions.visibilityTooltips.',
      rawOptionLabels: true,
    },
    [FilterField.MESSAGE_ORIGIN]: {
      kind: FilterFieldKind.CHECKBOX_GROUP,
      label: 'messages.data.origin',
      optionLabelPrefix: 'messages.origin.',
      defaultChecked: true,
    },
    [FilterField.MESSAGE_EVENTS]: {
      kind: FilterFieldKind.MULTISELECT,
      label: 'messages.data.event',
    },
    [FilterField.MESSAGE_ADMIN_ALERTS]: {
      kind: FilterFieldKind.RADIO_GROUP,
      label: 'messages.filters.adminAlerts.title',
      optionLabelPrefix: 'messages.filters.adminAlerts.',
      rawOptionLabels: true,
      defaultOption: MessageAdminAlertsFilter.ALL,
      nestedUnder: { field: FilterField.MESSAGE_ORIGIN, option: MessageOrigin.AUTOMATIC },
    },
    [FilterField.MESSAGE_DELIVERY_STATUS]: {
      kind: FilterFieldKind.CHECKBOX_GROUP,
      label: 'messages.data.deliveryStatus',
      optionLabelPrefix: 'messages.deliveryStatuses.',
      rawOptionLabels: true,
    },
    [FilterField.MESSAGE_CHANNELS]: {
      kind: FilterFieldKind.CHECKBOX_GROUP,
      label: 'messages.data.channel',
      optionLabelPrefix: 'messages.channel.',
    },
  };

  // bookings keep their no-shows as a flag of their own, not as an expedition status
  public static BOOKING_FAULTS_STATUS = 'Faults';

  private static PENDING_STATUS_GROUP: IStatusGroupDefinition = {
    statuses: [ExpeditionStatus.OPEN, ExpeditionStatus.READY, ExpeditionStatus.ONGOING],
    multiple: true,
  };

  private static CANCELLED_STATUS_GROUP: IStatusGroupDefinition = {
    statuses: [ExpeditionStatus.DELETED],
    multiple: false,
  };

  public static EXPEDITION_STATUS_GROUPS: Partial<
    Record<FilterType, Partial<Record<ExpeditionStatusGroup, IStatusGroupDefinition>>>
  > = {
    [FilterType.BOOKINGS]: {
      [ExpeditionStatusGroup.PENDING]: APP.PENDING_STATUS_GROUP,
      [ExpeditionStatusGroup.FINISHED]: {
        statuses: [ExpeditionStatus.CLOSED, APP.BOOKING_FAULTS_STATUS],
        multiple: false,
      },
      [ExpeditionStatusGroup.CANCELLED]: APP.CANCELLED_STATUS_GROUP,
    },
    [FilterType.TRIPS]: {
      [ExpeditionStatusGroup.PENDING]: APP.PENDING_STATUS_GROUP,
      [ExpeditionStatusGroup.FINISHED]: {
        statuses: [ExpeditionStatus.CLOSED, ExpeditionStatus.INCOMPLETED],
        multiple: true,
      },
    },
    [FilterType.AVAILABILITIES]: {
      [ExpeditionStatusGroup.PENDING]: APP.PENDING_STATUS_GROUP,
    },
  };

  public static MESSAGE_RECEIVER_USER_STATUS: UserStatus[] = [UserStatus.ACTIVE, UserStatus.BLOCKED];

  public static MESSAGE_DELIVERY_STATUSES: readonly MessageStatus[] = [
    MessageStatus.SUCCESS,
    MessageStatus.PROCESSING,
    MessageStatus.FAILED,
  ];

  public static MESSAGE_MANUAL_CHANNELS: readonly MessageChannel[] = [
    MessageChannel.EMAIL,
    MessageChannel.PUSH_NOTIFICATION,
    MessageChannel.SMS,
  ];

  public static NOTIFICATION_ADDITIONAL_COST_CHANNELS: readonly NotificationChannel[] = [
    NotificationChannel.SMS,
    NotificationChannel.WHATSAPP,
  ];

  public static MESSAGE_RECEIVER_EXPEDITION_STATUS: ExpeditionStatus[] = [
    ExpeditionStatus.OPEN,
    ExpeditionStatus.READY,
    ExpeditionStatus.ONGOING,
    ExpeditionStatus.CLOSED,
  ];

  public static FILTER_SERVICE_SCOPED_LISTS: FilterListKey[] = ['ROUTES', 'EXPEDITIONS'];

  public static FILTER_OPTION_KINDS: FilterFieldKind[] = [
    FilterFieldKind.CHECKBOX_GROUP,
    FilterFieldKind.RADIO_GROUP,
    FilterFieldKind.OPTION_MULTISELECT,
  ];

  private static FILTER_EXPEDITION_TYPE_OPTIONS =Object.values(ExpeditionType).filter(
    (type) => type !== ExpeditionType[''],
  );

  public static FILTER_CHECKBOX_OPTIONS: Partial<Record<FilterField, readonly string[]>> = {
    [FilterField.EXPEDITION_TYPES]: APP.FILTER_EXPEDITION_TYPE_OPTIONS,
    [FilterField.EXPEDITION_MODES]: APP.FILTER_EXPEDITION_TYPE_OPTIONS,
    [FilterField.SERVICE_TYPES]: Object.values(ServiceType),
    [FilterField.BOOKINGS]: Object.values(BookingsFilter),
    [FilterField.USER_STATUS]: Object.values(UserStatus),
    [FilterField.USER_TYPES]: Object.values(UserType),
    [FilterField.SUGGESTION_STATUS]: Object.values(SuggestionStatus),
    [FilterField.SUGGESTION_TYPES]: Object.values(SuggestionType),
    [FilterField.SUGGESTION_PRIORITIES]: Object.values(SuggestionPriority),
    [FilterField.SUGGESTION_USER_RESOLUTIONS]: Object.values(SuggestionUserResolutionFilter),
    [FilterField.SUGGESTION_VISIBILITIES]: Object.values(SuggestionVisibility),
    [FilterField.MESSAGE_ORIGIN]: Object.values(MessageOrigin),
    [FilterField.MESSAGE_ADMIN_ALERTS]: Object.values(MessageAdminAlertsFilter),
    [FilterField.MESSAGE_DELIVERY_STATUS]: APP.MESSAGE_DELIVERY_STATUSES,
    [FilterField.MESSAGE_CHANNELS]: Object.values(MessageChannel),
    [FilterField.CLIENT_TYPES]: Object.values(ClientType),
    [FilterField.APP_STATUS]: Object.values(AppStatusFilter),
  };

  public static SUGGESTION_TYPE_OPTIONS: Record<CommunicationUserType, readonly string[]> = {
    [CommunicationUserType.USERS]: Object.values(SuggestionType),
    [CommunicationUserType.DRIVERS]: Object.values(DriverSuggestionType),
  };

  // SUGGESTIONS SORT
  public static SUGGESTIONS_SORT_PARAM = 'sort';
  public static SUGGESTIONS_DIRECTION_PARAM = 'direction';
  public static SUGGESTIONS_DEFAULT_DIRECTIONS: Record<SuggestionSortType, SortDirection> = {
    [SuggestionSortType.CREATION]: SortDirection.DESC,
    [SuggestionSortType.LAST_MODIFICATION]: SortDirection.DESC,
    [SuggestionSortType.PRIORITY]: SortDirection.DESC,
    [SuggestionSortType.STATUS]: SortDirection.ASC,
  };

  // RESTRICTIONS
  public static RESTRICTIONS_NAME_COLLATOR = new Intl.Collator(undefined, { sensitivity: 'base' });
}
